import {
  Component,
  OnInit,
  Input,
  Output,
  SimpleChanges,
  EventEmitter,
} from '@angular/core';
import { SlokaTypeModel } from '../../interfaces/interfaces';
import { Observable, BehaviorSubject } from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'input-cmp',
  templateUrl: './input.component.html',
})
export class InputComponent implements OnInit {
  @Input() placeholder: string = '';
  @Input() isLogin: string = 'false';
  @Input() type: string = 'text';
  @Input() isAdd: string = 'false';
  @Input() isSlokaTypeTextArea: string = 'false';
  @Input() isSlokaTextArea: string = 'false';
  @Input() isUpload: string = 'false';
  @Input() isAudio: string = 'false';
  @Input() isPdf: string = 'false';
  @Input() isSelect: string = 'false';
  @Input() selectedValue: string = '';
  @Input() isEdit: boolean = false;
  @Input() isView: boolean = false;
  @Input() isViewImage: boolean = false;
  @Input() isMultiple: boolean = false;
  @Input() isPriceType: boolean = false;
  @Input() isStartDate: boolean = false;
  @Input() isEndDate: boolean = false;
  @Input() imageLink: string = '';
  @Input() isSelectSlokasList: string = 'false';
  @Input() inputText: string = '';
  @Input() startDateGot: string = '';
  @Input() endDateGot: string = '';
  @Input() ticketType: string = '';
  @Input() list: SlokaTypeModel[] = [];
  @Output() output = new EventEmitter<any>();
  @Output() imageDeleteOutput = new EventEmitter<string>();
  @Output() startDateOutput = new EventEmitter<string>();
  @Output() endDateOutput = new EventEmitter<string>();

  isReadOnlySubject = new BehaviorSubject<boolean>(false);
  isReadOnly$ = this.isReadOnlySubject.asObservable();
  dropDownValue$ = new BehaviorSubject<string>('');

  startDate: string = ""
  startTime: string = ""
  endDate: string = ""
  endTime: string = ""

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes.isEdit != 'undefined')
      this.isReadOnlySubject.next(!changes.isEdit.currentValue);
  }
  ngOnInit(): void {

    this.isEdit
      ? this.isReadOnlySubject.next(false)
      : this.isReadOnlySubject.next(true);

      if(this.startDateGot != "") {
       this.startDate = moment(this.startDateGot).format("YYYY-MM-DD");
       this.startTime = moment(this.startDateGot).format("HH:mm");
      }

      if(this.endDateGot != "") {
        this.endDate = moment(this.endDateGot).format("YYYY-MM-DD");
        this.endTime = moment(this.endDateGot).format("HH:mm");
      }

      //console.log(this.ticketType)
      
      
  }

  onInputChange(e: any) {
    let value = e.target.value;
    if (
      this.isUpload == 'true' ||
      this.isAudio == 'true' ||
      this.isPdf == 'true'
    ) {
      this.output.emit(e.target.files);
      return;
    } else if (this.isSelect === 'true' || this.isSelectSlokasList === 'true') {
      let selectedSlokaType = this.list.filter((f) => f.id == value)[0];
      this.output.emit(selectedSlokaType);
      this.dropDownValue$.next(selectedSlokaType.id);
      return;
    } else {
      this.output.emit(value);
      return;
    }
  }

  onStartDate(e: any) {
    let value = e.target.value;
    this.startDate = value;
    const date = new Date(`${value} ${this.startTime}`).toISOString();
    this.startDateOutput.emit(date)
  }

  onStartTime(e: any) {
    let value = e.target.value;
    this.startTime = value
    const date = new Date(`${this.startDate} ${value}`).toISOString();
    this.startDateOutput.emit(date)
  }

  onEndDate(e: any) {
    let value = e.target.value;
    this.endDate = value
    const date = new Date(`${value} ${this.endTime}`).toISOString();
    this.endDateOutput.emit(date)
  }

  onEndTime(e: any) {
    let value = e.target.value;
    this.endTime = value
    const date = new Date(`${this.endDate} ${value}`).toISOString();
    this.endDateOutput.emit(date)
  }

  onDeleteImageClick(e: any) {
      this.imageDeleteOutput.emit(e);

  }
}
